import { BoxProps, ColorOptions } from '@jfs/ui-new'
const styles = {
  footerBackground: {
    boxShadow: '0px 4px 4px #00000029' as ColorOptions,
    bg: 'WHITE',
  } as BoxProps,
  container: {
    display: 'flex',
    // flex: 1,
    flexDirection: 'column',
    zIndex: 1,
    overflow: 'scroll',
    position: 'relative',
    bg: 'WHITE',
    h: 'calc(100vh - 72px)',
  } as BoxProps,
}

export { styles }
